import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LOAD,
  LOAD_END,
} from "../../../../../../../store/actions/actionsTypes";
import { RootState } from "../../../../../../../store/reducers/rootReducer";
import {
  GET_PDF_TEUDOT,
  STATIC_PATH_V2,
} from "../../../../../../modules/API/settings";

export interface IUseDriversPrint {
  printPdf: (CODE: number, SUBCODE: number) => Promise<void>;
  printLogPdf: (areaID?: number) => Promise<void>;
}

/** Отдаёт PDF-поток новой вкладкой. */
const openPdfStream = async (response: Response): Promise<void> => {
  const blob = await response.blob();
  const file = new Blob([blob], { type: "application/pdf" });
  window.open(URL.createObjectURL(file));
};

export const useDriversPrint = (date: string): IUseDriversPrint => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.mainReducer.token);

  const printPdf = useCallback(
    async (CODE: number, SUBCODE: number) => {
      dispatch({ type: LOAD });
      try {
        const response = await fetch(
          `${GET_PDF_TEUDOT}deliveryNum=${CODE}&deliverySub=${SUBCODE}`,
          { headers: { Authorization: "Bearer " + token } }
        );
        await openPdfStream(response);
      } catch {
        // легаси молча проглатывал ошибку печати
      } finally {
        dispatch({ type: LOAD_END });
      }
    },
    [dispatch, token]
  );

  const printLogPdf = useCallback(
    async (areaID?: number) => {
      dispatch({ type: LOAD });
      try {
        const response = await fetch(
          !areaID
            ? `${STATIC_PATH_V2}driver/actions_log/pdf?Date=${date}`
            : `${STATIC_PATH_V2}driver/actions_log/pdf?Date=${date}&TransferZone=${areaID}`,
          { headers: { Authorization: "Bearer " + token } }
        );
        await openPdfStream(response);
      } catch {
        // легаси молча проглатывал ошибку печати
      } finally {
        dispatch({ type: LOAD_END });
      }
    },
    [dispatch, token, date]
  );

  return { printPdf, printLogPdf };
};

export default useDriversPrint;
